/** App roles (must match Entra App Role values and api/auth/roles.py). */
export const Role = {
  Admin: 'Admin',
  EventManager: 'EventManager',
  MarketingCreative: 'MarketingCreative',
  SalesRelationship: 'SalesRelationship',
} as const

/** Roles allowed to perform admin writes / access the admin console. */
export const ADMIN_ROLES = [
  Role.Admin,
  Role.EventManager,
  Role.MarketingCreative,
]
